<ng-lottie [styles]="styles"
           [options]="options" />
